module.exports = __webpack_public_path__ + "images/business-class/feature-butler.e2436c87d32c2f1ecb71.svg";